var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"text-center",attrs:{"variant":"info","show":_vm.display}},[_c('nuxt-link',{attrs:{"to":_vm.localePath('/clients/trusted')}},[_vm._v("\n    "+_vm._s(_vm.$t('clients.becomeTrusted'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }